import { Link } from "gatsby";
import React from "react";

function QualityPolicyBanner() {
  return (
    <div className="bg-qualityPolicy bg-cover bg-center bg-no-repeat py-16">
      <div className="w-full px-9 sm:px-0 sm:w-10/12 max-w-5xl mx-auto">
        <h1 className="text-40 leading-[55px] text-white font-secondary font-semibold mb-7">
          Quality at Every Step:&nbsp;
          <span className="block">The Tomedes Guarantee</span>
        </h1>
        <p className="text-base leading-7 text-white font-opensans mb-[3.75rem] sm:mb-[2.75rem]">
          At Tomedes, ensuring that our clients are satisfied with our work is
          not just a passion, but an obsession. This is why we have continuously
          strived to bring the quality of our language services up to exacting,
          institutionally-recognized global standards. With 95,000+ clients
          served and a 98% satisfaction rate, we can confidently say that we
          have the foundation to provide you with services of the highest
          quality, every single time.
        </p>
        {/* <div className="grid grid-cols-3 lg:grid-cols-5 justify-items-center lg:justify-items-start items-center gap-y-4 max-w-lg">
          <img
            src="https://tomedes.gumlet.io/assets/quality-policy/accreditation/9001.webp"
            alt="ISO 9001"
          />
          <img
            src="https://tomedes.gumlet.io/assets/quality-policy/accreditation/17100.webp"
            alt="ISO 17100"
          />
          <img
            src="https://tomedes.gumlet.io/assets/quality-policy/accreditation/18587.webp"
            alt="ISO 18578"
          />
          <img
            src="https://tomedes.gumlet.io/assets/quality-policy/accreditation/clutch.webp"
            alt="clutch"
          />
          <img
            src="https://tomedes.gumlet.io/assets/quality-policy/accreditation/USCIS-01.svg"
            alt="USCIS"
          />
        </div> */}
        <Link
          className="fr-btn2 uppercase rounded-full bg-orange hover:bg-newOrange-100 transition-colors duration-300 text-white  cursor-pointer text-17 font-semibold py-[20px] px-[60px] w-[253px] text-center "
          href="/contactus.php"
        >
          Contact Us
        </Link>
      </div>
    </div>
  );
}

export default QualityPolicyBanner;
